import { SelectionModel } from '@angular/cdk/collections';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { AlertComponent } from 'src/app/core/components/alert/alert.component';
import { ConfigService } from 'src/app/shared/services/config.service';
import { SpecificationService } from '../../../services/specification.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-shipment-specification-table',
  templateUrl: './shipment-specification-table.component.html',
  styleUrls: ['./shipment-specification-table.component.scss'],
})
export class ShipmentSpecificationTableComponent implements OnInit, OnChanges, OnDestroy {
  @Input() searchTerm: string = '';
  @Output() editSpecEvent = new EventEmitter();
  @Output() downloadSpec = new EventEmitter();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  dataSource = new MatTableDataSource<any>();
  selection = new SelectionModel<any>(true, []);
  specificationList = [];
  displayedColumns = ['select', 'specId', 'fileFormat', 'spec', 'action'];
  selectedSpecification = [];
  expandedElement = null;
  detailExpandValue = 'collapsed';
  csvFileDetails;
  allSpecificationList = [];
  excelHeader = [];
  subscription = new Subscription();

  constructor(
    private configService: ConfigService,
    private dialog: MatDialog,
    private specificationService: SpecificationService
  ) {}

  ngOnInit(): void {
    this.selectedSpecification = [];
    this.getSpecificationList();
    this.subscription.add(
      this.specificationService.onSpecUpdateAndCreation.subscribe(onSubmit => {
        if (onSubmit) {
          this.getSpecificationList();
        }
      })
    );
    this.subscription.add(
      this.specificationService.onSpecDeleteClick.subscribe(onDeleteClick => {
        if (onDeleteClick) {
          this.openDialogDelete(this.selectedSpecification);
        }
      })
    );
  }

  ngOnChanges(simpleChange: SimpleChanges) {
    if (simpleChange.searchTerm) {
      this.filterBySearch(simpleChange.searchTerm.currentValue);
    }
  }

  filterBySearch(searchTerm: string) {
    if (searchTerm && searchTerm.trim() !== '') {
      const filterValue = this.allSpecificationList.filter(
        item => item?.specifications_id.toLowerCase()?.indexOf(searchTerm.toLowerCase()) > -1
      );
      this.dataSource.data = this.setDataforTable(filterValue);
    } else {
      this.dataSource.filter = '';
      this.dataSource.data = this.setDataforTable(this.allSpecificationList);
    }
  }

  getSpecificationList() {
    this.subscription.add(
      this.configService.getListOfMappings('customer_mapping_specifications').subscribe(data => {
        this.specificationList = data[0];
        this.allSpecificationList = data[0];
        this.searchTerm?.trim()
          ? this.filterBySearch(this.searchTerm)
          : this.assignDataSource(data[0]);
      })
    );
  }

  assignDataSource(data: any) {
    this.dataSource.data = this.setDataforTable(data);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  setDataforTable(data: any) {
    const arr = data.map(e => {
      return {
        specId: e.specifications_id,
        fileFormat: e.file_format,
        spec: `${e.specifications_id} - ${e.file_format}`,
        _id: e._id,
      };
    });
    return arr;
  }

  masterToggle() {
    this.isEntirePageSelected()
      ? this.selection.deselect(...this.getPageData())
      : this.selection.select(...this.getPageData());
    this.updateSelection();
  }

  getPageData() {
    return this.dataSource._pageData(this.dataSource._orderData(this.dataSource.data));
  }

  isEntirePageSelected() {
    return this.getPageData().every(row => this.selection.isSelected(row));
  }

  updateSelection() {
    this.selectedSpecification = this.selection.selected.map(item => item._id);
    this.specificationService.specificationDeletionList.next(this.selectedSpecification);
  }

  getSelectMappingOption(specId: string) {
    return this.configService
      .getMappingFromOption('customer_mapping_specifications', specId)
      .toPromise();
  }

  openDialogDelete(specs: any) {
    const dailogData = {
      message: 'alert.deleteSpecification',
    };
    const alertDialog = this.dialog.open(AlertComponent, {
      data: dailogData,
    });
    alertDialog.afterClosed().subscribe(res => {
      if (res == 'true') {
        const reqBody = {
          body: {
            id: specs,
          },
        };
        this.subscription.add(
          this.configService.deleteConfig(reqBody).subscribe(() => {
            this.getSpecificationList();
            this.selectedSpecification = [];
            this.selection = new SelectionModel<any>(true, []);
            this.specificationService.specificationDeletionList.next(this.selectedSpecification);
            this.specificationService.onSpecDeleteClick.next(false);
          })
        );
      } else {
        this.dialog.closeAll();
      }
    });
  }

  editSpec(spec: any) {
    this.editSpecEvent.emit(spec);
  }

  importSpec(element: any) {
    this.getSelectMappingOption(element.specId).then(res => {
      this.downloadSpec.emit(res[0]);
    });
  }

  downloadSpecification(element: any) {
    this.csvFileDetails = null;
    this.getSelectMappingOption(element.specId).then(res => {
      this.csvFileDetails = res[0];
      this.csvFileDetails.data = res[0]?.data.map(item => (item === 'TBA' ? 'Blank' : item));
      this.specificationService.downloadJson(
        this.csvFileDetails,
        this.csvFileDetails.specifications_id
      );
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
